import PageAiHero from "./PageAiHero";

export default class PageAI {
    constructor() {
        this.init();
    }

    init() {
        this.initHero();
        this.initTabsAnchors();
        this.initGridLoadMore();
    }

    initHero() {
        const hero = document.getElementById("ai-hero-banner");
        if (hero) {
            new PageAiHero(hero, {
                fadeInDuration: 0.5,
                fadeOutDuration: 0.5,
                color: '#E5E6E5',
                radius: 3.5,
                numCircles: 11,
                minSpeed: 70,
                maxSpeed: 100
            });
        }
    }

    initTabsAnchors() {
        const hash = window.location.hash;

        setTimeout(() => {
            if(hash) {
                const tab = document.querySelector(hash);
                if(tab) {
                    const tab_anchor_id = tab.getAttribute('data-simple-tab-content');

                    if(tab_anchor_id) {
                        const tab_anchor = document.querySelector(`[data-simple-tab="${tab_anchor_id}"] a`);

                        if(tab_anchor) {
                            tab_anchor.click();
                        }
                    }
                }
            }
        }, 1000);
    }

    initGridLoadMore() {
        const gridSection = document.querySelector('.open-source-dev-projects');
        if (gridSection) {
            const loadMoreBtn = gridSection.querySelector('[data-simple-show-more-button]');
            const postsList = gridSection.querySelector('.author-post-list');
            if (loadMoreBtn && postsList) {
                loadMoreBtn.addEventListener('click', (e) => {
                    const hiddenPosts = postsList.querySelectorAll('.hidden-widescreen');
                    const postsToShow = Array.from(hiddenPosts).slice(0, 2);
                    postsToShow.forEach(post => {
                        post.classList.remove('hidden-widescreen');
                        post.classList.remove('hidden-desktop');
                    });
                });
            }
        }
    }
}
